import { render, staticRenderFns } from "./SuppliesOrders.vue?vue&type=template&id=df911004"
import script from "./SuppliesOrders.vue?vue&type=script&lang=js"
export * from "./SuppliesOrders.vue?vue&type=script&lang=js"
import style0 from "./SuppliesOrders.vue?vue&type=style&index=0&id=df911004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports